import { Injectable } from '@angular/core';

import { HttpService, NotificationService, TmsWebBaseEditService } from 'tms-lib';
import { PackType } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class PackTypeService extends TmsWebBaseEditService<PackType, PackType> {
  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super('PackType', $localize`Pack Type`, httpService, notificationService);
  }
}
